module.exports = __webpack_public_path__ + "img/dashboard-1.f4e60f64.png";